export function useFormatScore(score: number | null) {
    if (score === null) {
        return 0
    }

    return score
}
